import {
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Box,
	Divider,
	FormControl,
	InputLabel,
	Select,
	Stack,
	TextField,
	Tooltip,
	Accordion,
	MenuItem,
	OutlinedInput,
	InputAdornment,
} from "@mui/material";
import React, {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useTranslation } from "react-i18next";
import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
import CommonGrid from "../../Repository/CommonGrid";
import { SectionHeader } from "./SectionHeader";
import SourceType from "../../TemplateProperties/SourceType";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import FormattingOptions from "./FormattingOptions";
import {
	constantValueDropDown,
	dateIntervalDropDown,
	fieldTypeOptionsArray,
	onErrorDropDown,
	variableActionList,
} from "../../../constants/constantList";
import { ConstantValueControl } from "./OutboundFieldFormattingOptions/ConstantValueControl";
import {
	debounceFunction,
	filterInNodeTypes,
	getNodesByIcon,
	isParentKeyValueTrueNested,
	normalizeVariableActionEncodedFields,
} from "../../../utils/utilFunctions";
import { cloneDeep, debounce, set } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { getUpdatedData } from "../../RightContextMenu/ContextActions/NewRecordOutbound";
import { treeActions } from "../../../redux/slices/treeSlice";
import LightTooltip from "../../../commonComponents/LightTooltip";
import { FormattingOptionsSection } from "./OutboundFieldFormattingOptions/FormattingOptionsSection";
import WorkflowSourceType from "../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType";
import ResizableBox from "../../Common/ResizableBox";

const VariableProperties = () => {
	const { t } = useTranslation();
	const addToWorkflowSession = useRef(false);
	const parentScreen = useContext(ParentScreenCtx);
	const queryParams = useSelector((state) => state.queryParams);
	const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
	const currentTab = rightTree.currentTab;
	const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
	const translatedDataRef = useRef(translatedData);
	const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
	const selectedNodeRef = useRef(selectedNode);
	const [fieldType, setFieldType] = useState("SELECT");
	const [fieldOptions, setFieldOptions] = useState([]);
	const [variableNameDropDown, setVariableNameDropDown] = useState([]);
	const [variableName, setVariableName] = useState('');
	const [initialValue, setInitialValue] = useState('');
	const [sessionValue, setSessionValue] = useState('');
	const sessionValueRef = useRef('');
	const [applyFieldProp, setApplyFieldProp] = useState("FALSE");
	const [variableAction, setVariableAction] = useState('');
	const [gridAPI, setGridAPI] = useState();
	const [selectedAction, setSelectedAction] = useState({});
	const [rowData, setRowData] = useState([]);
	const [resetBeforeUse, setResetBeforeUse] = useState(false);
	const [resetValue, setResetValue] = useState('');
	const [incrementBy, setIncrementBy] = useState('');
	const [onError, setOnError] = useState("TRUE");
	const [defaultValue, setDefaultValue] = useState('');
	const [constantValue, setConstantValue] = useState('');
	const [repeatTimes, setRepeatTimes] = useState("1");
	const [ignoreGlobalSubstitution, setIgnoreGlobalSubstitution] =
		useState("FALSE");
	const [bitPosition, setBitPosition] = useState("1");
	const [bitValue, setBitValue] = useState("0");
	const [actionDropDownMenu, setActionsDropDownMenu] = useState([]);
	const dispatch = useDispatch();
	const [dateInterval, showDateInterval] = useState(false);
	const [dateIntervalValue, setDateIntervalValue] = useState('');
	const variableNameRef = useRef(t("VARUNNAMED"));
	const fieldOptionsDropdownArray = cloneDeep(fieldTypeOptionsArray);
	fieldOptionsDropdownArray.splice(1, null, { value: "CONSTANT", text: "CONSTANT" })
	const wfItemId = selectedNode?.ID;
	const fieldOptionsDropdown = useMemo(
		() => [...fieldOptionsDropdownArray],
		[]
	);
	const [doNotLog, setDoNotLog] = useState(false);
	const [disableWFItem, setDisableWFItem] = useState(false);
	const [globalSession, setGlobalSession] = useState(false);
	const [parentLogWFItemChecked, setParentLogWFItemChecked] = useState(false);

	const newAction = {
			ACTION: "SET",
			FIELDTYPE: "ALPHA",
			FILLCHAR: " ",
			NAME: selectedNode?.NAME || t("VARUNNAMED"),
			PADDIR: "RIGHT"
	}

	const bitPositionDropdown = useMemo(
		() =>
			["1", "2", "3", "4", "5", "6", "7", "8"].map((e, i) => (
				<MenuItem key={`bitPosition-${i}`} value={e}>
					{e}
				</MenuItem>
			)),
		[]
	);

	const dateIntervalOptions = dateIntervalDropDown.map((e, i) => {
		return (
			<MenuItem key={"dateInterval" + i} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});

	const bitValueDropdown = useMemo(() =>
		["0", "1"].map(
			(e, i) => (
				<MenuItem key={`bitValue-${i}`} value={e}>
					{e}
				</MenuItem>
			),
			[]
		)
	);

	const variableActionDropDown = variableActionList.map((e, i) => {
		return (
			<MenuItem key={"variableAction" + i} value={e.value}>
				{t(e.text)}
			</MenuItem>
		);
	});

	const onErrorDropDownMenu = onErrorDropDown.map((e, i) => {
		return (
			<MenuItem key={"variableAction" + i} value={e.value}>
				{t(e.text)}
			</MenuItem>
		);
	});

	const constantValueDropDownMenu = ["", t("CRLF"), t("RECORD_DELIMITER")];

	const customClickHandlerOnAdd = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		let nodeWithSessionValues;

		e.api.forEachNode((node) => {
			data.push({...node.data, NAME: selectedNodeRef.current?.NAME || node.data?.NAME});
			if (node?.data?.WF_SESSION_NAME || node?.data?.FORMAT_WFSESSION_VAR)
				nodeWithSessionValues = node.data;
		});

		let wfSessionValues = {};

		if (nodeWithSessionValues && Object.keys(nodeWithSessionValues).length) {
			if (nodeWithSessionValues.WF_SESSION_NAME) wfSessionValues["WF_SESSION_NAME"] = nodeWithSessionValues.WF_SESSION_NAME;
			if (nodeWithSessionValues.FORMAT_WFSESSION_VAR) wfSessionValues["FORMAT_WFSESSION_VAR"] = nodeWithSessionValues.FORMAT_WFSESSION_VAR;
		}

		if (!data.length && addToWorkflowSession.current && sessionValueRef.current)
			wfSessionValues["WF_SESSION_NAME"] = sessionValueRef.current;

		let haveInitialValue = {};
		if (data.length > 0 && data[0]?.hasOwnProperty("START_VALUE"))
			haveInitialValue = { START_VALUE: data[0].START_VALUE };

		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
			...newAction,
			NAME: selectedNodeRef.current?.NAME || newAction?.NAME,
			ACTION: data?.length ? "CONCATENATE" : "SET",
			...wfSessionValues,
			...haveInitialValue
		});
		variableActionsHandler(
			[...data],
			data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
			e.api
		);
		submitHandler("VARIABLE", data);
	};

	const deleteActionHandler = (e) => {
		const data = [];
		e.api.forEachNode((node) => {
			if (e.data.id !== node.data.id) data.push(node.data);
		});
		variableActionsHandler([...data], 0, e.api);
		submitHandler("VARIABLE", data);
	};

	const copyActionHandler = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, selectedRows?.[0]);
		variableActionsHandler([...data], +selectedRows?.[0]?.id + 1, e.api);
		submitHandler("VARIABLE", data);
	};

	const handleFieldTypeDropdown = (currentAction) => {
		if (!gridAPI) return;
		const nodes = [];
		gridAPI.forEachNode((node) => {
			if (Number(currentAction?.id) > Number(node?.data?.id)) {
				nodes.push(node.data);
			}
		});
		let availableFieldTypeDropdown = fieldOptionsDropdown.filter((e) =>
			(parentScreen === "outbound" ? availableFieldType : availableFieldTypeWorkflow)?.[currentAction?.ACTION]?.includes(e?.value)
		);
		nodes.forEach((e) => {
			if (e?.FIELDTYPE === "DATE" && ["ADD", "SUBTRACT"].includes(currentAction?.ACTION)) {
				availableFieldTypeDropdown = availableFieldTypeDropdown.filter(e => {
					return !["FLOAT"].includes(e?.value)
				})
				return;
			}
		});
		setFieldOptions(
			availableFieldTypeDropdown.map((e, i) => {
				return (
					<MenuItem key={`fieldType-${i}`} value={e?.value}>
						{t(e.text)}
					</MenuItem>
				);
			})
		);
	};

	useEffect(() => {
		if ((fieldTypeSupportedVariableAction.includes(selectedAction?.ACTION) && parentScreen === "outbound") || 
			(fieldTypeSupportedVariableActionWorkflow.includes(selectedAction?.ACTION) && parentScreen === "workflow")) {
			handleFieldTypeDropdown(selectedAction)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedAction?.ACTION, setSelectedAction?.id]);

	useEffect(() => {
		selectedNodeRef.current = selectedNode;
	}, [selectedNode]);

	let gridOptions = {
		columnDefs: [
			{
				addNewControl: true,
				addControlLabel: t("HOVER_MSSG_ADD_VARIABLE_ACTION"),
				customClickHandlerOnAdd: customClickHandlerOnAdd,
				headerName: t("LBL_VAR_ACTIONS"),
				field: "key",
				editable: false,
				resizable: false,
				cellRenderer: (info) => CustomCellRenderer(info),
				rowDrag: true,
			},
		],
		onRowDragEnd: function (event) {
			// Handle row drag end event here
			const newRowData = [];
			const selectedNodes = event.api.getSelectedRows();
			let newSelectedId = null;
			event.api.forEachNodeAfterFilterAndSort(function (node, i) {
				newRowData.push({ ...node.data, id: i });
				if (selectedNodes[0]?.id === node.data.id) newSelectedId = i;
			});
			submitHandler("VARIABLE", newRowData);
			event.api.setGridOption('rowData', newRowData)
			if (newSelectedId !== null)
				variableActionsHandler(newRowData, newSelectedId, event.api);
		},
		rowDragManaged: true,
	}

	const CustomCellRenderer = (info) => {
		const { value, data } = info;
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					height: "2rem",
				}}
			>
				<div className='truncated-text' title={value}>
					{value}
				</div>
				<div className='flex align-center'>
					<LightTooltip title={t('DELETE')} onClick={() => deleteActionHandler(info)}>
						<span
							style={{ cursor: "pointer" }}
							className='DELETE_MUI'
						// onClick={() => handleDelete(value, data?.data)}
						></span>
					</LightTooltip>
					<LightTooltip title={t('MNU_COPY')} onClick={() => copyActionHandler(info)}>
						<span
							style={{ cursor: "pointer" }}
							className='FILE_COPY'
						// onClick={() => handleCopy(value, data?.data)}
						></span>
					</LightTooltip>
				</div>
			</div>
		);
	};

	const formattingOptionHandler = (prop, newVal, bulk) => {
		debounceActionHandler(prop, newVal, bulk);
	};

	const variableNameDropDownHandler = (variableNodes) => {
		const uniqueNodes = [];
		variableNodes?.forEach((e) =>
			(!uniqueNodes?.includes(e?.NAME) && e?.NAME) ? uniqueNodes.push(e?.NAME || '') : null
		);
		const menuItems = uniqueNodes?.map((e, i) => {
			return e;
		});
		setVariableNameDropDown(menuItems);
	};

	const submitHandler = (key, value, bulk, removeValues) => {
		const clonedData = cloneDeep(translatedDataRef.current);
		let found = false;
		eachDeep(clonedData, (obj) => {
			if (found) return;
			if (obj?.key === selectedNode?.key) {
				found = true;
				if (key) {
					if (key === "NAME") {
						obj.title = `${parentScreen === "outbound" ? t("VARIABLE_") : ""} ${value ? value : t("VARUNNAMED")}`;
						obj.NAME = value ? value : t("VARUNNAMED");
						if (obj?.VARIABLE?.length) obj.VARIABLE = obj?.VARIABLE.map(e => {
							e.NAME = value;
							return e;
						})
						variableNameRef.current = obj?.NAME;
					} else if (key === "WF_SESSION_NAME" || key === "FORMAT_WFSESSION_VAR") {
						obj?.VARIABLE?.forEach((action) => {
							if (key === "WF_SESSION_NAME" && !action?.WF_SESSION_NAME && value)
								action.FORMAT_WFSESSION_VAR = "FALSE";
							if (value === "")
								action.hasOwnProperty(key) && delete action[key];
							else
								action[key] = value;
						})
					} else if (key === "VARIABLE") {
						obj.VARIABLE = Array.isArray(value)
							? value.map((row) => normalizeVariableActionEncodedFields(row))
							: value;
					} else obj[key] = value;
				} else {
					Object.keys(bulk).forEach((e) => {
						obj[e] = bulk[e];
					});
				}
				if (removeValues?.length) {
					removeValues.forEach((e) => {
						if (obj?.hasOwnProperty(e)) delete obj[e];
					});
				}
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: rightTree.currentTab,
						data: obj,
					})
				);
			}
		});
		dispatch(
			treeActions.setRightTreeTransData({
				screen: parentScreen,
				type: rightTree.currentTab,
				data: clonedData,
			})
		);
	};

	const getCleanedData = (data, obj) => {
		// // Todo Clean data to save in redux
		// const cleanedData = data.map((e) => {
		// 	if (e?.hasOwnProperty("id")) delete e.id;
		// 	if (e?.hasOwnProperty("key")) delete e.key;
		// 	if (e?.hasOwnProperty("CHANGED")) delete e.CHANGED;
		// 	if (e?.hasOwnProperty("FILLCHAR") && e.FILLCHAR === "SPACE") e.FILLCHAR = "+";
		// 	if (e?.hasOwnProperty("RPT_TRUNC_ERR") && e.RPT_TRUNC_ERR === "TRUE") delete e.RPT_TRUNC_ERR;
		// 	if (e?.hasOwnProperty("REPEAT") && !e?.hasOwnProperty("LENGTH")) delete e.REPEAT; //TODO: fix repeat and length logic
		// 	if (["ALPHA", "DATE"].includes(e?.FIELDTYPE) && !e?.hasOwnProperty("LENGTH")) e.LENGTH = "0"
		// 	if (obj?.NAME) e["NAME"] = variableNameRef.current;

		// 	//remove empties
		// 	Object.keys(e).forEach((objKey) => {
		// 		if (e[objKey] === "") delete e[objKey];
		// 	})

		// 	return e;
		// });
		// return cleanedData;
	};

	const sourceTypeValuesHandler = (values, sourceType) => {
		const { PARENT, MAPNAME, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, SOURCE_REPEATING_FIELD } = values;
		const newObj = { PARENT, MAPNAME, RECORD_TYPE, MAP_REPETITION_INDEX, SOURCE_REPEATING_FIELD,CUSTOM_DB_FIELD, PLUGIN_NAME, VARIABLE_COLLECTION_ACTION: ACTION, VARIABLE_COLLECTION_INDEX: INDEX, WF_ITEM_ID, WF_ITEM_LOCATION, isDateMapped: values?.FIELDTYPE === "DATE", ...(values?.FIELDTYPE === "DATE" ? {INBOUND_PATTERN: values?.PATTERN} : {}), ...(sourceType ? { SOURCE_TYPE: sourceType } : {}) };
		submitActionHandler(null, null, newObj);
	};

	const submitActionHandler = (key, value, bulk, removeValues) => {
		//TODO: "PATTERN" showing when it shouldnt in ALPHA fieldtype
		// if (key === 'PATTERN') console.log(key, value);
		let nodes = [];
		if (gridAPI) {
			gridAPI.forEachNode((node, index) => {
				const tempNode = cloneDeep(node.data);
				if (key === "START_VALUE") {
					if (index === 0) {
						tempNode[key] = value;
						(value === "" && tempNode.hasOwnProperty(key)) && delete tempNode[key];
					}
				}
				if (selectedAction?.id === node.data.id) {
					if (key) {
						if (key === "START_VALUE") { }
						else
							tempNode[key] = value;
					} else {
						Object.keys(bulk).forEach((e) => {
							if ((bulk[e] === undefined || bulk[e] === null) && tempNode?.hasOwnProperty(e)) delete tempNode[e];
							else tempNode[e] = bulk[e];
						});
					}
					if (removeValues?.length) {
						removeValues.forEach((e) => {
							if (tempNode?.hasOwnProperty(e)) delete tempNode[e];
						});
					}
				}
				nodes.push(tempNode);
			});
		}
		nodes = filterActionsData(nodes);
		variableActionsHandler(nodes, selectedAction.id, gridAPI, true);
		submitHandler("VARIABLE", nodes);
	};

	const filterActionsData = (nodes) => {
		return nodes.map(e => {
			const action = e?.ACTION;
			if ((!fieldTypeSupportedVariableAction.includes(action) && parentScreen === "outbound") || (!fieldTypeSupportedVariableActionWorkflow.includes(action) && parentScreen === "workflow")) {
				if (e?.hasOwnProperty("FIELDTYPE")) delete e?.FIELDTYPE; // In this Case Action Object doesn't support FieldType so delete FIELDTYPE property from JSON;
				if (action === "COUNT") {
					// In this case we see only below controls so those three controls value should be in the JSON;
					const validJSONKeys = ["ACTION", "NAME", "INCREMENT", "RESET_VALUE", "WF_SESSION_NAME", "FORMAT_WFSESSION_VAR", "START_VALUE"];
					Object.keys(e).forEach(key => {
						if (!validJSONKeys.includes(key)) delete e?.[key];
					})
				}
				else if (((nonFieldTypeSupportedVariableAction.includes(action) && parentScreen === "outbound") || (nonFieldTypeSupportedVariableActionWorkflow.includes(action) && parentScreen === "workflow")) && action !== "ESCAPE_XML_DATA") {
					// In this case we see only below controls so those three controls value should be in the JSON;
					const validJSONKeys = ["ACTION", "NAME", "KEEP_ORIG_DATA_ON_ERROR", "DEFAULT_VALUE", "WF_SESSION_NAME", "FORMAT_WFSESSION_VAR", "START_VALUE"];
					Object.keys(e).forEach(key => {
						if (!validJSONKeys.includes(key)) delete e?.[key];
					})
				}
				else if (["ESCAPE_XML_DATA", "RESET"].includes(action)) {
					// In this case we see only below controls so those three controls value should be in the JSON;
					const validJSONKeys = ["ACTION", "NAME", "WF_SESSION_NAME", "FORMAT_WFSESSION_VAR", "START_VALUE"];
					Object.keys(e).forEach(key => {
						if (!validJSONKeys.includes(key)) delete e?.[key];
					})
				}
			} else {
				const validJSONKeys = ["ACTION", "NAME", "FIELDTYPE", "WF_SESSION_NAME", "FORMAT_WFSESSION_VAR", "START_VALUE", ...(supportedJSONValuesForFieldTypes?.[e?.FIELDTYPE] || [])];
				Object.keys(e).forEach(key => {
					if (!validJSONKeys.includes(key) || e[key] === null) delete e?.[key];
				})
			}

			return e;
		})
	}

	const debounceChangeHandler = useCallback(debounce(submitHandler, 400), [
		rightTree.currentTab,
		rightTree.tree,
		rightTree.tree[rightTree.currentTab].translatedData,
		selectedNode?.key,
	]);

	const debounceActionHandler = useCallback(
		debounce(submitActionHandler, 400),
		[
			rightTree.currentTab,
			rightTree.tree,
			rightTree.tree[rightTree.currentTab].translatedData,
			selectedAction,
		]
	);

	const onSelectHandler = (gridOptions) => {
		const selectedRows = gridOptions.api.getSelectedRows();
		if (selectedRows.length) setSelectedAction(selectedRows[0]);
	};

	const variableActionsHandler = (data = [], selectionIndex, gridAPI, avoidSelection) => {
		if (!gridAPI) {
			setRowData([]);
			return;
		}

		let decodedValue;

		if (data[0]?.VALUE)
			decodedValue = (data[0]?.VALUE);

		const rowData = data?.map((e, i) => {
			if (i === 0)
				setInitialValue(e?.START_VALUE || "");
			let title = `${t(e?.ACTION)}-`;
			if (e?.FIELDTYPE === "CONSTANT") title += `"${e?.VALUE || ""}"`;
			else if (e?.RECORD_TYPE && e?.MAPNAME && t("SELECT") !== e?.MAPNAME && parentScreen === "outbound")
				title += `${(e?.RECORD_TYPE)}/${e?.MAPNAME}`;
			else if (parentScreen === "workflow")
				title += `${e?.RECORD_TYPE ? `${t(e?.RECORD_TYPE)}/` : ""}${e?.WFITEM ? `${e?.WFITEM}/` : ""}${e?.WFITEM === "Trading Partner Lookup" ? (e?.MAPNAME || "") : t(e?.MAPNAME || "")}`;
			return {
				...e,
				key: title,
				id: i,
			};
		});
		gridAPI.setGridOption("rowData", rowData);
		setTimeout(() => {
			gridAPI.forEachNode((node) => {
				if (node?.data?.id === selectionIndex) {
					node.setSelected(true);
					if (!avoidSelection) {
						setSelectedAction(node.data);
						gridAPI.ensureNodeVisible(node);
					}
				}
			});
			if (!rowData?.length && !avoidSelection) setSelectedAction({});
		}, 100);
	};

	const setActionsDropdown = (currentAction) => {
		if (!gridAPI) return;
		const nodes = [];
		gridAPI.forEachNode((node) => {
			if (Number(currentAction?.id) > Number(node?.data?.id)) {
				nodes.push(node.data);
			}
		});
		const hasPrecedingDate = nodes.some((node) => node?.FIELDTYPE === "DATE");
		const supportsDateIntervalFieldType = ["CONSTANT", "INTEGER", "DATE"].includes(currentAction?.FIELDTYPE);
		showDateInterval(hasPrecedingDate && supportsDateIntervalFieldType);

		if (parentScreen === "workflow") {
			setActionsDropDownMenu(
				variableActionList.map((e, i) => {
					return (
						<MenuItem key={"variableAction" + i} value={e.value}>
							{t(e.text)}
						</MenuItem>
					);
				})
			);
			return;
		}
		let newOptions = [];
		let supportedAction = [];
		if (hasPrecedingDate) {
			supportedAction = [
				"SET",
				"CONCATENATE",
				"CONVERT_TO_FIELD_TYPE",
				"ESCAPE_XML_DATA",
				"ADD",
				"SUBTRACT",
				"DATE_DIFF",
			];
		} else if (nodes.some((e) => e?.ACTION === "CONCATENATE")) {
			supportedAction = [
				"SET",
				"CONCATENATE",
				"CONVERT_TO_FIELD_TYPE",
				"ESCAPE_XML_DATA",
			];
		} else {
			supportedAction = variableActionList.map((e) => e?.value);
		}
		if (!nodes?.length) {
			supportedAction = variableActionList.map((e) => e?.value);
		}
		newOptions = variableActionList.filter((e) => {
			return supportedAction.includes(e?.value);
		});
		setActionsDropDownMenu(
			newOptions.map((e, i) => {
				return (
					<MenuItem key={"variableAction" + i} value={e.value}>
						{t(e.text)}
					</MenuItem>
				);
			})
		);
	};

	useEffect(() => {
		const bodyVariable = getNodesByIcon(
			rightTree?.tree?.["body"]?.translatedData,
			["VARIABLE", "VARIABLE_ITEM"]
		);
		const headerVariable = getNodesByIcon(
			rightTree?.tree?.["header"]?.translatedData,
			["VARIABLE", "VARIABLE_ITEM"]
		);
		const trailerVariable =
			currentTab === "trailer"
				? getNodesByIcon(rightTree?.tree?.["trailer"]?.translatedData, [
					"VARIABLE", "VARIABLE_ITEM"
				])
				: [];
		variableNameDropDownHandler([
			...bodyVariable,
			...headerVariable,
			...trailerVariable,
		]);
		variableActionsHandler(selectedNode?.VARIABLE || [], 0, gridAPI);
		variableNameRef.current = selectedNode?.NAME
		setVariableName(selectedNode?.NAME || t('VARIABLE'));
		setInitialValue(selectedNode?.VARIABLE?.[0]?.START_VALUE || "");
		setApplyFieldProp(selectedNode?.VARIABLE?.[0]?.FORMAT_WFSESSION_VAR === "TRUE" ? "TRUE" : "FALSE");
		setSessionValue(selectedNode?.VARIABLE?.[0]?.WF_SESSION_NAME || "");
		addToWorkflowSession.current = selectedNode?.VARIABLE?.[0]?.WF_SESSION_NAME ? true : false;
		setDoNotLog(selectedNode?.LOG_WFITEM_DETAILS === "FALSE");
		setDisableWFItem(selectedNode?.ENABLED === "FALSE");
		setGlobalSession(selectedNode?.ISGLOBAL === "TRUE");
		const isLogWFItemDetailsFalse = isParentKeyValueTrueNested("LOG_WFITEM_DETAILS", "FALSE",translatedData, selectedNode);
		setParentLogWFItemChecked(isLogWFItemDetailsFalse);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedNode?.key, currentTab, gridAPI]);

	useEffect(() => {
		return () => {
			setSelectedAction({});
		};
	}, [selectedNode?.key, currentTab]);

	useEffect(() => {
		//TODO: this useEffect is running when controls change value, such as repeatTimes state.
		// find new approach.
		setVariableAction(selectedAction?.ACTION || "");
		setFieldType(selectedAction?.FIELDTYPE || "");
		setIncrementBy(selectedAction?.INCREMENT || "");
		setResetBeforeUse(selectedAction?.RESET_VALUE ? true : false);
		setResetValue(selectedAction?.RESET_VALUE || "");
		setOnError(selectedAction?.KEEP_ORIG_DATA_ON_ERROR || "TRUE");
		setDefaultValue(selectedAction?.DEFAULT_VALUE || '');
		setConstantValue((selectedAction?.VALUE) || "");
		setRepeatTimes(selectedAction?.REPEAT || "1");
		setIgnoreGlobalSubstitution(selectedAction?.IGNORE_GLOBAL_SUB === "TRUE");
		setBitPosition(selectedAction?.BIT_POSITION || "1");
		setBitValue(selectedAction?.VALUE || "0");
		setActionsDropdown(selectedAction);
		setDateIntervalValue(selectedAction?.UNIT || 'DAY')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedAction?.ACTION, selectedAction?.FIELDTYPE, selectedAction?.id]);

	useEffect(() => {
		// Persist default date interval when UI turns it on, even without user interaction.
		if (!dateInterval || !selectedAction?.hasOwnProperty("id")) return;
		if (selectedAction?.UNIT) return;
		debounceActionHandler("UNIT", "DAY");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dateInterval, selectedAction?.id, selectedAction?.UNIT]);

	useEffect(() => {
		sessionValueRef.current = sessionValue;
	}, [sessionValue]);

	useEffect(() => {
		translatedDataRef.current = translatedData;
	}, [translatedData]);

	return (
		<Box sx={{ padding: "15px 15px" }}>
			<Stack spacing={"15px"}>
				<Autocomplete
					size="small"
					variant="outlined"
					className="width-100"
					freeSolo
					options={variableNameDropDown}
					value={variableName}
					inputValue={variableName}
					onBlur={(e) => {
						if (!e?.target?.value) setVariableName(t("VARUNNAMED"));
					}}
					onInputChange={(event, newValue) => {
						if (!event) return;
						const value = event.target.value
							? event.target.value
							: t("VARUNNAMED");
						setVariableName(event.target.value);
						debounceChangeHandler("NAME", `${value}`);
					}}
					onChange={(event, newValue) => {
						setVariableName(newValue || "");
						debounceChangeHandler("NAME", newValue);
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							size="small"
							label={t("LBL_VAR_NAME")}
							slotProps={{
								input: {
									...params.InputProps,
									...(parentScreen === "workflow" && {
										endAdornment: (
											<>
												{params.InputProps.endAdornment}
												<InputAdornment position="end">
													<div style={styles.getDataNameAdornment}>{`ID: ${wfItemId}`}</div>
												</InputAdornment>
											</>
										)
									})
								}
							}}
						/>
					)}
				/>
				<FormControl variant='outlined' className='width-100' size='small'>
					<TextField

						autoComplete={"off"}
						size='small'
						value={initialValue}
						label={t("LBL_INIT_VAL")}
						disabled={Object.keys(selectedAction).length === 0}
						onChange={(e) => {
							const { value } = e.target;
							setInitialValue(value);
							debounceActionHandler("START_VALUE", value);
						}}
					/>
				</FormControl>
				{parentScreen === "outbound" ? <Box
					variant='outlined'
					sx={{ display: "flex", flexDirection: "column"}}
					className='width-100'
					size='small'
				>
					<LabeledCheckbox
						label={t("BTN_ADD_TO_WF_SESSION")}
						handleCheck={(checked) => {
							addToWorkflowSession.current = checked;
							if (checked) {
								setSessionValue(variableName);
								gridAPI && gridAPI.forEachNode((node) => {
									node.data.WF_SESSION_NAME = variableName;
									node.data.FORMAT_WFSESSION_VAR = "FALSE";
								})
								debounceChangeHandler(
									"WF_SESSION_NAME",
									variableName
								);
								setApplyFieldProp("FALSE");
							}
							if (!checked) {
								gridAPI && gridAPI.forEachNode((node) => {
									if (node?.data?.hasOwnProperty("WF_SESSION_NAME")) delete node?.data?.WF_SESSION_NAME;
								})
								debounceChangeHandler("WF_SESSION_NAME", "");
							}
						}}
						checked={addToWorkflowSession.current}
					/>
					{addToWorkflowSession.current && <LightTooltip>
						<TextField
							autoComplete={"off"}
							label={t("LBL_WORKFLOW_SESSION_NAME")}
							sx={{ width: "100%", margin: "10px 0 5px" }}
							size='small'
							value={sessionValue}
							onChange={(e) => {
								const { value } = e.target;
								setSessionValue(value);
								gridAPI && gridAPI?.forEachNode((node) => {
									node.data.WF_SESSION_NAME = value;
								})
								debounceChangeHandler("WF_SESSION_NAME", value);
							}}
						/>
					</LightTooltip>}
					<LabeledCheckbox
						disabled={!addToWorkflowSession.current}
						label={t("BTN_APPLY_FIELD_PROPERTIES")}
						handleCheck={(checked) => {
							gridAPI && gridAPI.forEachNode((node) => {
								node.data.FORMAT_WFSESSION_VAR = checked ? "TRUE" : "FALSE";
							})
							setApplyFieldProp(checked ? "TRUE" : "FALSE");
							debounceChangeHandler(
								"FORMAT_WFSESSION_VAR",
								checked ? "TRUE" : "FALSE"
							);
						}}
						checked={applyFieldProp === "TRUE"}
					/>
				</Box> : <Box
					variant='outlined'
					sx={{ display: "flex", flexWrap: "wrap" }}
					className='width-100'
					size='small'
				>
					<LabeledCheckbox
						label={t("LBL_LOG_NO_WFITEM_DETAILS")}
						handleCheck={(checked) => {
							setDoNotLog(checked);
							debounceChangeHandler(
								"LOG_WFITEM_DETAILS",
								checked ? "FALSE" : "TRUE"
							);
						}}
						disabled={parentLogWFItemChecked}
						checked={doNotLog}
					/>
					<LabeledCheckbox
						label={t("LBL_DISABLE_WFITEM")}
						handleCheck={(checked) => {
							setDisableWFItem(checked);
							debounceChangeHandler(
								"ENABLED",
								checked ? "FALSE" : "TRUE"
							);
						}}
						checked={disableWFItem}
					/>
					<LabeledCheckbox
						label={t("LBL_GLOBAL_SESSION")}
						handleCheck={(checked) => {
							setGlobalSession(checked);
							debounceChangeHandler(
								"ISGLOBAL",
								checked ? "TRUE" : "FALSE"
							);
						}}
						checked={globalSession}
					/>
				</Box>}
				<Divider />
				{/* <Box className='div-textBox-action'> */}
				<ResizableBox>
					<CommonGrid
						rowData={rowData}
						gridOptions={gridOptions}
						containerStyle={{ height: "100% !important" }}
						gridResizable={true}
						getGridAPI={(e, gridRef) => {
							setGridAPI(gridRef.api);
							variableActionsHandler(selectedNode?.VARIABLE || [], 0);
						}}
						gridProps={{
							overlayNoRowsTemplate: t("NO_DATA_MSSG_VARIABLE_ACTION"),
							rowSelection: "single",
							onSelectionChanged: onSelectHandler,
						}}
					/>
				</ResizableBox>
				{/* </Box> */}
				<FormControl variant='outlined' className='width-100' size='small'>
					<InputLabel>{t("LBL_VAR_ACTION")}</InputLabel>
					<Select
						disabled={!selectedAction?.ACTION}
						variant='outlined'
						size='small'
						className={"width-100"}
						value={actionDropDownMenu?.filter(e => e?.props.value === variableAction)?.length ? variableAction : ''}
						onChange={(e) => {
							const value = e.target.value;
							setVariableAction(value);
							debounceActionHandler(null, null, {
								"ACTION": value,
								...(
									value === "COUNT" ? { INCREMENT: "1" } : {}
								),
							});
						}}
						MenuProps={{
						PaperProps: {
								sx: {
								maxHeight: "250px",
								"&::-webkit-scrollbar": {
									width: "8px",
								},
								"&::-webkit-scrollbar-thumb": {
									backgroundColor: "#888",
									borderRadius: "4px",
								},
								"&::-webkit-scrollbar-thumb:hover": {
									backgroundColor: "#555",
								},
								},
							},
						}}
					>
						{actionDropDownMenu}
					</Select>
				</FormControl>
				{selectedAction?.ACTION ? (
					<>
						{((fieldTypeSupportedVariableAction.includes(variableAction) && parentScreen === "outbound") || 
							(fieldTypeSupportedVariableActionWorkflow.includes(variableAction) && parentScreen === "workflow")) ? (
							<FormControl
								variant='outlined'
								className='width-100'
								size='small'
							>
								<InputLabel>{t("LBL_FIELD_TYPE")}</InputLabel>
								<Select
									variant='outlined'
									size='small'
									className={"width-100"}
									value={
										fieldOptions.filter((e) => e.props.value === fieldType)
											?.length
											? fieldType
											: fieldOptions?.length ? "SELECT" : ''
									}
									onChange={(e) => {
										const value = e.target.value;
										setFieldType(value);
										debounceActionHandler(null, null, {
											"FIELDTYPE": e.target.value,
											...(
												value === "CONSTANT" ? { REPEAT: "1" } :
													value === "BIT_FLAG" ? { BIT_POSITION: "1", VALUE: "0" } :
														value === "ALPHA" ? { PADDIR: "RIGHT", FILLCHAR: " " } :
															value === "DATE" ? { KEEP_ORIG_DATA_ON_ERROR: "TRUE", PADDIR: "RIGHT", FILLCHAR: " ", VALUE: null } :
																value === "INTEGER" ? { KEEP_ORIG_DATA_ON_ERROR: "TRUE", VALUE: null } :
																	value === "PACKED_INT" ? { KEEP_ORIG_DATA_ON_ERROR: "TRUE", VALUE: null } :
																		value === "ZONED_INT" ? { KEEP_ORIG_DATA_ON_ERROR: "TRUE", VALUE: null } :
																			value === "FLOAT" ? { KEEP_ORIG_DATA_ON_ERROR: "TRUE", VALUE: null } : {}
											)
										});

									}}
								>
									{fieldOptions}
								</Select>
							</FormControl>
						) : (
							<>
								{["COUNT"].includes(variableAction) && (
									<>
										<FormControl
											variant='outlined'
											className='width-100'
											size='small'
										>
											<TextField
												autoComplete={"off"}
												label={t("LBL_INC_BY")}
												sx={{ width: "100%" }}
												size='small'
												value={incrementBy}
												onChange={(e) => {
													const { value } = e.target;
													const newValue = value.substring(0, 9).replaceAll(/\D/g, "");
													setIncrementBy(newValue);
													debounceActionHandler("INCREMENT", newValue);
												}}
											/>
										</FormControl>
										<div className='flex flex-wrap'>
											<LabeledCheckbox
												checked={resetBeforeUse}
												handleCheck={(checked) => {
													setResetBeforeUse(checked);
												}}
												label={t("BTN_RESET_BEFORE_USE")}
											/>
										</div>
										{resetBeforeUse && (
											<FormControl
												variant='outlined'
												className='width-100'
												size='small'
											>
												<TextField
													autoComplete={"off"}
													label={t("LBL_RESET_VAL")}
													sx={{ width: "100%" }}
													size='small'
													value={resetValue}
													onChange={(e) => {
														const { value } = e.target;
														setResetValue(value);
														debounceActionHandler("RESET_VALUE", value);
													}}
												/>
											</FormControl>
										)}
									</>
								)}
								{((nonFieldTypeSupportedVariableAction.includes(variableAction) && parentScreen === "outbound") || 
								(nonFieldTypeSupportedVariableActionWorkflow.includes(variableAction) && parentScreen === "workflow")) && variableAction !== "ESCAPE_XML_DATA" && (
										<>
											<FormControl className='width-100' size='small'>
												<InputLabel id='onError'>{t("LBL_ON_ERR")}</InputLabel>
												<Select
													variant='outlined'
													size='small'
													className={"width-100"}
													value={onError}
													onChange={(e) => {
														setOnError(e.target.value);
														debounceActionHandler(
															"KEEP_ORIG_DATA_ON_ERROR",
															e.target.value
														);
													}}
												>
													{onErrorDropDownMenu}
												</Select>
											</FormControl>
											{onError === "FALSE" && (
												<FormControl className='width-100' size='small'>
													<TextField
														autoComplete={"off"}
														variant='outlined'
														size='small'
														label={t("LBL_DEFAULT_VALUE")}
														className={"width-100"}
														name='PATTERN'
														value={defaultValue}
														onChange={(e) => {
															setDefaultValue(e.target.value);
															debounceActionHandler(
																"DEFAULT_VALUE",
																e.target.value
															);
														}}
													/>
												</FormControl>
											)}
										</>
									)}
							</>
						)}

						{fieldType === "CONSTANT" &&
							((fieldTypeSupportedVariableAction.includes(variableAction) && parentScreen === "outbound") || (fieldTypeSupportedVariableActionWorkflow.includes(variableAction) && parentScreen === "workflow")) && (
								<>
									<ConstantValueControl
										constantValue={constantValue}
										setConstantValue={(value) => {
											setConstantValue(value);
											if (selectedAction?.REPEAT && selectedAction?.LENGTH) {
												//change length based on constant value * repeat times
												const newLength = (parseInt(repeatTimes)) * (value?.length || 0);
												debounceActionHandler(null, null, {
													VALUE: (value),
													LENGTH: newLength.toString()
												})
											} else {
												debounceActionHandler("VALUE", (value));
											}
										}}
										constantValueOptions={constantValueDropDownMenu}
									/>
									{dateInterval ? (
										<FormControl className='width-100' size='small'>
											<InputLabel id='convertCase'>
												{t("LBL_DATE_INTERVAL")}
											</InputLabel>
											<Select
												variant='outlined'
												size='small'
												className={"width-100"}
												value={dateIntervalValue}
												onChange={(e) => {
													setDateIntervalValue(e.target.value);
													debounceActionHandler("UNIT", e.target.value);
												}}
											>
												{dateIntervalOptions}
											</Select>
										</FormControl>
									) : (
										<FormControl
											variant='outlined'
											className='width-100'
											size='small'
										>
											<TextField
												autoComplete={"off"}
												size='small'
												value={repeatTimes}
												label={t("LBL_REPEAT_#_TIMES")}
												onChange={(e) => {
													const value = (typeof e?.target?.value === "string" && e?.target?.value !== "") ? e?.target?.value : "";
													const newValue = value.substring(0, 9).replaceAll(/\D/g, "");
													if (newValue !== repeatTimes) {
														const newLength = parseInt(newValue) * constantValue.length;
														//TODO: repeatTimes state getting reset by selectedAction useEffect
														setRepeatTimes(newValue);
														debounceActionHandler(null, null, { "REPEAT": newValue, "LENGTH": newLength.toString() });
													}
												}}
											/>
										</FormControl>
									)}
									{selectedAction?.FIELDTYPE !== "CONSTANT" && <div className='flex flex-wrap'>
										<LabeledCheckbox
											checked={ignoreGlobalSubstitution}
											handleCheck={(checked) => {
												setIgnoreGlobalSubstitution(checked);
												debounceActionHandler(
													"IGNORE_GLOBAL_SUB",
													checked ? "TRUE" : "FALSE"
												);
											}}
											label={t("IGNORE_GLOBAL_SUB")}
										/>
									</div>}
								</>
							)}

						{fieldType === "BIT_FLAG" &&
							((fieldTypeSupportedVariableAction.includes(variableAction) && parentScreen === "outbound") || 
							(fieldTypeSupportedVariableActionWorkflow.includes(variableAction) && parentScreen === "workflow")) && (
								<>
									<FormControl
										variant='outlined'
										className='width-100'
										size='small'
									>
										<InputLabel>{t("LBL_BIT_POSITION")}</InputLabel>
										<Select
											variant='outlined'
											size='small'
											className={"width-100"}
											value={bitPosition}
											onChange={(e) => {
												const { value } = e.target;
												setBitPosition(value);
												debounceActionHandler("BIT_POSITION", value);
											}}
										>
											{bitPositionDropdown}
										</Select>
									</FormControl>
									<FormControl
										variant='outlined'
										className='width-100'
										size='small'
									>
										<InputLabel>{t("LBL_BIT_VALUE")}</InputLabel>
										<Select
											variant='outlined'
											size='small'
											className={"width-100"}
											value={bitValue}
											onChange={(e) => {
												const { value } = e.target;
												setBitValue(value);
												debounceActionHandler("VALUE", value);
											}}
										>
											{bitValueDropdown}
										</Select>
									</FormControl>
								</>
							)}

						{[
							"DATE",
							"ALPHA",
							"INTEGER",
							"FLOAT",
							"ZONED_INT",
							"PACKED_INT",
							"INTEGER",
						].includes(fieldType) && fieldType !== "SELECT" && !["CONVERT_TO_FIELD_TYPE"].includes(variableAction) &&
							((fieldTypeSupportedVariableAction.includes(variableAction) && parentScreen === "outbound") 
							|| (fieldTypeSupportedVariableActionWorkflow.includes(variableAction) && parentScreen === "workflow")) && fieldOptions?.filter((e) => e?.props?.value === fieldType)?.length > 0 && (
								parentScreen === "outbound" ? <>
									<Accordion defaultExpanded sx={styles.accordianContainer}>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls='accordianFormattingOptions'
											id='dataSource'
											className='accordian-override'
											sx={styles.accordianHeader}
										>
											<SectionHeader text={`${t("LBL_DATA_SOURCE")}`} />
										</AccordionSummary>
										<AccordionDetails sx={styles.accordianContent}>
											<Stack spacing={"10px"} marginTop={"10px"}>
												{fieldType !== "CONSTANT" ? (
													selectedAction?.hasOwnProperty("id") ? <SourceType
														disabled={!selectedNode?.key}
														node={{
															PARENT: selectedAction?.PARENT,
															MAPNAME: selectedAction?.MAPNAME,
															RECORD_TYPE: selectedAction?.RECORD_TYPE,
															ACTION: selectedAction?.VARIABLE_COLLECTION_ACTION,
															INDEX: selectedAction?.VARIABLE_COLLECTION_INDEX,
															CUSTOM_DB_FIELD: selectedAction?.CUSTOM_DB_FIELD,
															PLUGIN_NAME: selectedAction?.PLUGIN_NAME,
															key: selectedAction?.id,
															MAP_REPETITION_INDEX: selectedAction?.MAP_REPETITION_INDEX,
														}}
														
														valuesHandler={sourceTypeValuesHandler}
														initialSelectCall={true}
													/> : ""
												) : (
													<FormControl className='width-100' size='small'>
														<TextField
															autoComplete={"off"}
															// disabled={!selectedNode?.key}
															variant='outlined'
															size='small'
															label={t("CONSTANT_VALUE")}
															className={"width-100"}
															value={""}
															onChange={(e) => {
																// setConstantValue(e?.target?.value);
																// debounceConditionHandler("VALUE", e?.target?.value);
															}}
														/>
													</FormControl>
												)}
											</Stack>
										</AccordionDetails>
									</Accordion>
									<Accordion sx={styles.accordianContainer} defaultExpanded>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls='accordianFormattingOptions'
											id='formattingOptions'
											className='accordian-override'
											sx={styles.accordianHeader}
										>
											<SectionHeader text={t("LBL_FORMATE_OPTIONS")} />
										</AccordionSummary>
										<AccordionDetails sx={styles.accordianContent}>
											{selectedAction && (
												<FormattingOptions
													node={selectedAction}
													valueshandler={formattingOptionHandler}
													showDateInterval={dateInterval}
													isDateMapped={selectedAction?.isDateMapped}
													callerComponent="variableProperties"
												/>
											)}
										</AccordionDetails>
									</Accordion>
								</> : <> <WorkflowSourceType

									node={{
										key: selectedAction?.id,
										RECORD_TYPE: selectedAction?.RECORD_TYPE,
										WFITEM: selectedAction?.WFITEM,
										OUTBOUND_NAME: selectedAction?.OUTBOUND_NAME,
										MAPNAME: selectedAction?.MAPNAME,
										WF_ITEM_ID: selectedAction?.WF_ITEM_ID,
										WF_ITEM_LOCATION: selectedAction?.WF_ITEM_LOCATION,
										CALL_WORKFLOW: selectedAction?.CALL_WORKFLOW,
										CALL_WORKFLOW_ACCOUNT: selectedAction?.CALL_WORKFLOW_ACCOUNT,
										CALL_WORKFLOW_GROUP: selectedAction?.CALL_WORKFLOW_GROUP,
										VALUE: selectedAction?.VALUE,
										INBOUND_PATTERN: selectedAction?.INBOUND_PATTERN,
										WF_ITEM_DEPENDENCY_TIMEOUT: selectedAction?.WF_ITEM_DEPENDENCY_TIMEOUT
									}}
									valuesHandler={(values) => {
										submitActionHandler(null, null, values);
									}}
									variableName={selectedNode?.NAME || ""}
									from="VARIABLE_PROPERTIES"
								/>
									<FormattingOptions node={selectedAction}
										valueshandler={formattingOptionHandler}
										showDateInterval={dateInterval}
										hideControls={["URLENCODE", "RPT_TRUNC_ERR", "IGNORE_GLOBAL_SUB"]}
										hideInboundPattern={parentScreen === "workflow"}
									/> 
								</>
							)}
						

					</>
				) : (
					""
				)}
			</Stack>
		</Box>
	);
};

export default VariableProperties;

const availableFieldType = {
	CONVERT_TO_FIELD_TYPE: ["SELECT", "ALPHA", "DATE", "FLOAT", "INTEGER"],
	SET: [
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"DATE",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CONCATENATE: [
		"SELECT",
		"ALPHA",
		"DATE",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ADD: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	SUBTRACT: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	MULTIPLY: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	DIVIDE: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	DATE_DIFF: [
		"SELECT",
		"DATE",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CEILING: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	FLOOR: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	MODULUS: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	POWER: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	RAND: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	ROUND: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	ROUND_UP: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ROUND_DOWN: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SUBSTRING_COUNT: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_1: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_224: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_256: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_384: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_512: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_MD5: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
};

const availableFieldTypeWorkflow = {
	CONVERT_TO_FIELD_TYPE: ["SELECT", "ALPHA", "DATE", "FLOAT", "INTEGER"],
	SET: [
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CONCATENATE: [
		"SELECT",
		"ALPHA",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ADD: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	SUBTRACT: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	MULTIPLY: [
		"SELECT",
		"CONSTANT",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	DIVIDE: ["SELECT", "CONSTANT", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"],
	ABS: [
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ACOS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ACRE_TO_HECTARE:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	DATE_DIFF: [
		"SELECT",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	"ACRE_TO_SQMETER" :[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ASCII_TO_ENCODE_HEX:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ASIN:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	BASE64_TO_STRING:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	BASE64URL_TO_STRING:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CEILING: [
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CENTIMETER_TO_FAHRENHEIT:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CENTIMETER_TO_INCHES:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CHAR:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	COS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CUBICFEET_TO_CUBICMETER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CUBICINCHES_TO_LITERS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CUBICMETER_TO_CUBICFEET:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CUBICMETER_TO_CUBICYARD:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CUBICYARD_TO_CUBICMETER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	CUBICMETER_TO_GALLON:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ENCODE_HEX_TO_ASCII:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	FAHRENHEIT_TO_CELSIUS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	FEET_TO_METERS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	FLOOR:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	GALLON_TO_CUBICMETER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	GRAMS_TO_OUNCES:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HECTARE_TO_ACRE:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HEXADECIMAL:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HEX_TO_DECIMAL:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	INCHES_TO_CENTIMETER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	INCHES_TO_MM:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	KG_TO_LBS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	KM_TO_MILES:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	LBS_TO_KG:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	LITERS_TO_CUBICINCHES:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	LITERS_TO_QUARTS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	LOG:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	LOG_10:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	METERS_TO_FEET:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	METERS_TO_YARD:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	MILES_TO_KM:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	MM_TO_INCHES:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],

	MODULUS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],

	ONCES_TO_GRAMS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],

	OCTAL:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],

	POWER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	RAND:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_1:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_224:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_256:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_384:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_SHA_512:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	HASH_MD5:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	QUARTS_TO_LITERS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ROUND:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ROUND_DOWN:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	ROUND_UP:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SIGN:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SIN:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQCENTIMETER_TO_SQINCHES:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],

	SQFEET_TO_SQMETER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQINCHES_TO_SQCENTIMETER:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQMETER_TO_ACRE:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQMETER_TO_SQFEET:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQMETER_TO_SQYARDS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQRT:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SQYARDS_TO_SQMETERS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	STRING_LENGTH:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	STRING_TO_BASE64:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	STRING_TO_BASE64URL:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	SUBSTRING_COUNT:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	TAN:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	TANH:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	TO_DEGREE:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	TO_RADIAN:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	YARDS_TO_METERS:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	URLENCODE:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	XML_TO_JSON:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	IS_VALID_XML:[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	"PRETTY_PRINT_XML":[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	"DE_IDENTIFY":[
		"SELECT",
		"ALPHA",
		"BIT_FLAG",
		"CONSTANT",
		"DATE",
		"FLOAT",
		"INTEGER",
		"PACKED_INT",
		"ZONED_INT",
	],
	
};

const fieldTypeSupportedVariableAction = [
	"CONVERT_TO_FIELD_TYPE",
	"SET",
	"CONCATENATE",
	"ADD",
	"SUBTRACT",
	"MULTIPLY",
	"DIVIDE",
	"DATE_DIFF",
	"CEILING",
	"FLOOR",
	"MODULUS",
	"POWER",
	"RAND",
	"HASH_SHA_1",
	"HASH_SHA_224",
	"HASH_SHA_256",
	"HASH_SHA_384",
	"HASH_SHA_512",
	"HASH_MD5",
	"ROUND",
	"ROUND_DOWN",
	"ROUND_UP",
	"SUBSTRING_COUNT",
]; 
const fieldTypeSupportedVariableActionWorkflow = [
	"CONVERT_TO_FIELD_TYPE",
	"SET",
	"CONCATENATE",
	"ADD",
	"SUBTRACT",
	"MULTIPLY",
	"DIVIDE",
	"DATE_DIFF",
	"CEILING",
	"FLOOR",
	"MODULUS",
	"POWER",
	"RAND",
	"HASH_SHA_1",
	"HASH_SHA_224",
	"HASH_SHA_256",
	"HASH_SHA_384",
	"HASH_SHA_512",
	"HASH_MD5",
	"ROUND",
	"ROUND_DOWN",
	"ROUND_UP",
	"SUBSTRING_COUNT",
	"ABS",
	"ACOS",
	"ACRE_TO_HECTARE",
	"ACRE_TO_SQMETER",
	"ASCII_TO_ENCODE_HEX",
	"ASIN",
	"BASE64_TO_STRING",
	"BASE64URL_TO_STRING",
	"CELSIUS_TO_FAHRENHEIT",
	"CENTIMETER_TO_INCHES",
	"CHAR",
	"COS",
	"CUBICFEET_TO_CUBICMETER",
	"CUBICINCHES_TO_LITERS",
	"CUBICMETER_TO_CUBICFEET",
	"CUBICMETER_TO_CUBICYARD",
	"CUBICMETER_TO_GALLON",
	"CUBICYARD_TO_CUBICMETER",
	"ENCODE_HEX_TO_ASCII",
	"ESCAPE_XML_DATA",
	"FAHRENHEIT_TO_CELSIUS",
	"FEET_TO_METERS",
	"GALLON_TO_CUBICMETER",
	"GRAMS_TO_OUNCES",
	"HECTARE_TO_ACRE",
	"HEXADECIMAL",
	"HEX_TO_DECIMAL",
	"INCHES_TO_CENTIMETER",
	"INCHES_TO_MM",
	"KG_TO_LBS",
	"KM_TO_MILES",
	"LBS_TO_KG",
	"LITERS_TO_CUBICINCHES",
	"LITERS_TO_QUARTS",
	"LOG",
	"LOG_10",
	"METERS_TO_FEET",
	"METERS_TO_YARDS",
	"MM_TO_INCHES",
	"MILES_TO_KM",
	"OUNCES_TO_GRAMS",
	"OCTAL",
	"QUARTS_TO_LITERS",
	"SIGN",
	"SIN",
	"SQCENTIMETER_TO_SQINCHES",
	"SQFEET_TO_SQMETER",
	"SQINCHES_TO_SQCENTIMETER",
	"SQMETER_TO_ACRE",
	"SQMETERS_TO_SQYARDS",
	"SQMETER_TO_SQFEET",
	"SQRT",
	"SQYARDS_TO_SQMETERS",
	"STRING_LENGTH",
	"STRING_TO_BASE64",
	"STRING_TO_BASE64URL",
	"TAN",
	"TANH",
	"TO_DEGREE",
	"TO_RADIAN",
	"YARDS_TO_METERS",
	"URLENCODE",
	"URLDECODE",
	"XML_TO_JSON",
	"IS_VALID_XML",
	"PRETTY_PRINT_XML",
	"DE_IDENTIFY"
];

const nonFieldTypeSupportedVariableAction = [
	"ABS",
	"ACOS",
	"ACRE_TO_HECTARE",
	"ACRE_TO_SQMETER",
	"ASCII_TO_ENCODE_HEX",
	"ASIN",
	"BASE64_TO_STRING",
	"BASE64URL_TO_STRING",
	"CELSIUS_TO_FAHRENHEIT",
	"CENTIMETER_TO_INCHES",
	"CHAR",
	"COS",
	"CUBICFEET_TO_CUBICMETER",
	"CUBICINCHES_TO_LITERS",
	"CUBICMETER_TO_CUBICFEET",
	"CUBICMETER_TO_CUBICYARD",
	"CUBICMETER_TO_GALLON",
	"CUBICYARD_TO_CUBICMETER",
	"ENCODE_HEX_TO_ASCII",
	"ESCAPE_XML_DATA",
	"FAHRENHEIT_TO_CELSIUS",
	"FEET_TO_METERS",
	"GALLON_TO_CUBICMETER",
	"GRAMS_TO_OUNCES",
	"HECTARE_TO_ACRE",
	"HEXADECIMAL",
	"HEX_TO_DECIMAL",
	"INCHES_TO_CENTIMETER",
	"INCHES_TO_MM",
	"KG_TO_LBS",
	"KM_TO_MILES",
	"LBS_TO_KG",
	"LITERS_TO_CUBICINCHES",
	"LITERS_TO_QUARTS",
	"LOG",
	"LOG_10",
	"METERS_TO_FEET",
	"METERS_TO_YARDS",
	"MM_TO_INCHES",
	"MILES_TO_KM",
	"OUNCES_TO_GRAMS",
	"OCTAL",
	"QUARTS_TO_LITERS",
	"SIGN",
	"SIN",
	"SQCENTIMETER_TO_SQINCHES",
	"SQFEET_TO_SQMETER",
	"SQINCHES_TO_SQCENTIMETER",
	"SQMETER_TO_ACRE",
	"SQMETERS_TO_SQYARDS",
	"SQMETER_TO_SQFEET",
	"SQRT",
	"SQYARDS_TO_SQMETERS",
	"STRING_LENGTH",
	"STRING_TO_BASE64",
	"STRING_TO_BASE64URL",
	"TAN",
	"TANH",
	"TO_DEGREE",
	"TO_RADIAN",
	"YARDS_TO_METERS",
	"URLENCODE",
	"URLDECODE",
	"XML_TO_JSON",
	"IS_VALID_XML",
	"PRETTY_PRINT_XML",
	"DE_IDENTIFY"
];
const nonFieldTypeSupportedVariableActionWorkflow = [
	
	
];

const styles = {
	getDataNameAdornment: {
		color: "#666666",
		fontSize: "9px",
		position: "absolute",
		right: "13px",
		top: "-6px",
		backgroundColor: "#FFF",
		zIndex: "2",
		padding: "0 5px",
		height: "12px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	fpContainer: {
		// padding: "0 16px 16px 16px"
		padding: "0 4px 4px 4px",
	},
	accordianContainer: {
		border: "none",
		padding: "0",
		margin: "0",
		boxShadow: "none",
		backgroundColor: "unset",
	},
	accordianHeader: {
		border: "none",
		padding: "0",
		margin: "0",
		backgroundColor: "unset",
	},
	accordianContent: {
		border: "none",
		padding: "0 0px",
		margin: "0",
		backgroundColor: "unset",
	},
	variableNameEndLabel: {
		color: "#666666",
		fontSize: "9px",
		position: "absolute",
		right: "13px",
		top: "-6px",
		backgroundColor: "#FFF",
		zIndex: "2",
		padding: "0 5px",
		height: "12px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	}
};


const supportedJSONValuesForFieldTypes = {
	CONSTANT: ["VALUE", "UNIT", "REPEAT", "IGNORE_GLOBAL_SUB" , "isDateMapped"],
	BIT_FLAG: ["BIT_POSITION", "VALUE" , "isDateMapped"],
	DATE: [
		"INBOUND_PATTERN",
		"PATTERN",
		"TIMEZONE",
		"FILLCHAR",
		"PADDIR",
		"LENGTH",
		"KEEP_ORIG_DATA_ON_ERROR",
		"VALUE",
		"UNIT",
		"TRIMDATA",
		"URLENCODE",
		"IGNORE_GLOBAL_SUB",
		"MASK",
		"FUNCTION",
		"SUBSTRING",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
		"PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
		"WF_ITEM_ID",
		"WF_ITEM_LOCATION",
		"CALL_WORKFLOW",
		"CALL_WORKFLOW_ACCOUNT",
		"CALL_WORKFLOW_GROUP",
		"OUTBOUND_NAME",
		"WFITEM",
		"isDateMapped"
	],
	ALPHA: [
		"CONVERT_CASE",
		"FILLCHAR",
		"PADDIR",
		"LENGTH",
		"TRIMDATA",
		"URLENCODE",
		"RPT_TRUNC_ERR",
		"IGNORE_GLOBAL_SUB",
		"REPLACE",
		"MASK",
		"FUNCTION",
		"SUBSTRING",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
		"PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
		"WF_ITEM_ID",
		"WF_ITEM_LOCATION",
		"CALL_WORKFLOW",
		"CALL_WORKFLOW_ACCOUNT",
		"CALL_WORKFLOW_GROUP",
		"OUTBOUND_NAME",
		"WFITEM",
		"isDateMapped",
		"PATTERN"
	],
	INTEGER: [
		"PATTERN",
		"ROUND",
		"PRECISION",
		"UNIT",
		"KEEP_ORIG_DATA_ON_ERROR",
		"VALUE",
		"TRIMDATA",
		"URLENCODE",
		"IGNORE_GLOBAL_SUB",
		"MASK",
		"FUNCTION",
		"SUBSTRING",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
		"PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
		"WF_ITEM_ID",
		"WF_ITEM_LOCATION",
		"CALL_WORKFLOW",
		"CALL_WORKFLOW_ACCOUNT",
		"CALL_WORKFLOW_GROUP",
		"OUTBOUND_NAME",
		"WFITEM",
		"isDateMapped",
		"PATTERN"
	],
	FLOAT: [
		"PATTERN",
		"ROUND",
		"PRECISION",
		"PRECISION",
		"KEEP_ORIG_DATA_ON_ERROR",
		"VALUE",
		"TRIMDATA",
		"URLENCODE",
		"ROUND",
		"IGNORE_GLOBAL_SUB",
		"MASK",
		"FUNCTION",
		"SUBSTRING",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
		"PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
		"WF_ITEM_ID",
		"WF_ITEM_LOCATION",
		"CALL_WORKFLOW",
		"CALL_WORKFLOW_ACCOUNT",
		"CALL_WORKFLOW_GROUP",
		"OUTBOUND_NAME",
		"WFITEM",
		"isDateMapped",
		"PATTERN"
	],
	ZONED_INT: [
		"PATTERN",
		"UNSIGNED",
		"PRECISION",
		"KEEP_ORIG_DATA_ON_ERROR",
		"VALUE",
		"TRIMDATA",
		"URLENCODE",
		"IGNORE_GLOBAL_SUB",
		"MASK",
		"FUNCTION",
		"SUBSTRING",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
		"PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
		"WF_ITEM_ID",
		"WF_ITEM_LOCATION",
		"CALL_WORKFLOW",
		"CALL_WORKFLOW_ACCOUNT",
		"CALL_WORKFLOW_GROUP",
		"OUTBOUND_NAME",
		"WFITEM",
		"isDateMapped",
		"PATTERN"
	],
	PACKED_INT: [
		"PATTERN",
		"UNSIGNED",
		"PRECISION",
		"KEEP_ORIG_DATA_ON_ERROR",
		"VALUE",
		"TRIMDATA",
		"URLENCODE",
		"IGNORE_GLOBAL_SUB",
		"MASK",
		"FUNCTION",
		"SUBSTRING",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
		"PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
		"WF_ITEM_ID",
		"WF_ITEM_LOCATION",
		"CALL_WORKFLOW",
		"CALL_WORKFLOW_ACCOUNT",
		"CALL_WORKFLOW_GROUP",
		"OUTBOUND_NAME",
		"WFITEM",
		"isDateMapped",
		"PATTERN"
	],
};